import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import { Row,Col, Card, Form, Button, } from 'react-bootstrap';
import {Helmet} from "react-helmet";
import $ from 'jquery';
import {
  getls, integerIndMobile, lettersOnly, integerAadhar, integerKeyPress, decimalKeyPress, upperCase
} from '../../../utils';
import axios from 'axios';

import PsContext from '../../context/PsContext';

class Profile extends Component{
	
	static contextType = PsContext;
	
	constructor(props){
		super(props);
		this.state = {
			
		}
		
		this.handleLogOut = this.handleLogOut.bind(this);
	}
	
	componentDidMount(){
		
		this.context.updateHeader({
			top: false,
			title: 'Profile',
			back: true,
		});
		
	}
	
	componentWillUnmount(){
		
		this.context.updateHeader({top: false});		
	}
	
	handleLogOut(){
		var $this = this;
		$.confirm({
			title: 'Confirm',
			content: 'Do you want to Logout?',
			buttons: {
				Yes: function(){
					$this.context.logout();
				},
				No : function(){ }
			},
		});
	}
	
	confirmLogout(){
			
	}
	
	render(){

		return(
			<div data-aos="fade">
				<div className="container" >
					
					<div className="card settings-card">
						<div className="card-body">
						  <div className="single-settings d-flex align-items-center justify-content-between">
							<div className="title">
								<i className="lni lni-user"></i>
								<span>View Profile</span>
							</div>
							<div className="data-content">
							  <Link to="/app/profile/view" className="font-20" >
								<i className="icofont-arrow-right"></i>
							  </Link>
							</div>
						  </div>
						</div>
					  </div>
					  
					  <div className="card settings-card">
						<div className="card-body">
						  <div className="single-settings d-flex align-items-center justify-content-between">
							<div className="title">
								<i className="lni lni-key"></i>
								<span>Update Password</span>
							</div>
							<div className="data-content">
							  <Link to="" className="font-20" >
								<i className="icofont-arrow-right"></i>
							  </Link>
							</div>
						  </div>
						</div>
					  </div>
					  
					  <div className="card settings-card">
						<div className="card-body">
						  <div className="single-settings d-flex align-items-center justify-content-between">
							<div className="title">
								<i className="lni lni-user"></i>
								<span>Logout</span>
							</div>
							<div className="data-content">
							  <a href="javascript:;" className="font-20" onClick={this.handleLogOut} >
								<i className="icofont-logout"></i>
							  </a>
							</div>
						  </div>
						</div>
					  </div>
					  
				</div>
			</div>
		);
	}
	
}
export default Profile;
